<template>
  <div class="mc-catalog">
    <Gender></Gender>
    <search></search>
    <div v-if="categoriesLoading" class="mc-loader">
      <span class="mc-loader__circle"></span>
    </div>
    <div v-if="categoriesError" class="mc-error">{{ categoriesError }}</div>

    <!-- Динамически отображаем категории первого уровня -->
    <section v-for="category in allCategories" :key="category.id" class="mc-category">
      <div class="mc-container">
        <div class="mc-category__title">
          <router-link :to="`/category/${category.id}/`">
            {{ category.name }}
        </router-link>
        </div>

        <!-- Для категории с дочерними элементами используем swiper -->
        <swiper
            v-if="category.children && category.children.length"
            wrapperTag="ul"
            :modules="modules"
            :pagination="false"
            :slides-per-view="3.505"
            :spaceBetween="10"
            :loop="false"
            :freeMode="true"
            class="mc-category__slider"
            wrapperClass="mc-category__list">

          <!-- Отображаем дочерние элементы категории -->
          <swiper-slide
            v-for="child in category.children"
            :key="child.id"
            class="mc-category__item"
            tag="li">
            <router-link :to="`/category/${child.id}/`" class="mc-category-card">
                <div class="mc-category-card__image-wrapper">
                <img class="mc-category-card__image"
                     :src="child.picture || '/assets/content/category/img-2.jpg'"
                     width="87" height="146"
                     :alt="child.name">
              </div>
              <div class="mc-category-card__name">
                {{ child.name }}
                </div>
            </router-link>
          </swiper-slide>

          <!-- Кнопка "Смотреть все" -->
          <swiper-slide class="mc-category__item" tag="li">
            <router-link :to="`/category/${category.id}/`" class="mc-button-all simulated-hover">
                Смотреть<br>
                все
            </router-link>
          </swiper-slide>
        </swiper>
        </div>
    </section>
        </div>
</template>

<script>
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import { Pagination, Navigation, Scrollbar } from 'swiper';
import search from './parts/Search.vue';
import { mapGetters, mapActions } from 'vuex';
import Gender from "@/views/blocks/Gender.vue";

export default {
    beforeRouteLeave(to, from) {
        //if (to.name != 'login')
        //  this.$store.dispatch('unLoader');
    },
    created() {
      // Загружаем категории только если они еще не были загружены
      this.loadCategoriesIfNeeded();
    },
    computed: {
      ...mapGetters([
        'user',
        'allCategories',
        'categoriesLoading',
        'categoriesError',
        'categoriesLoaded',
        'gender'
      ])
    },
    async mounted() {
      // Можно добавить дополнительную логику при необходимости
    },
    watch: {
      gender(newValue, oldValue) {
        if (oldValue && oldValue != newValue) {
          this.fetchCategories({update:true});
        }
      }
    },
    methods: {
      ...mapActions([
        'fetchCategories'
      ]),
      // Метод, который проверяет, нужно ли загружать категории
      loadCategoriesIfNeeded() {
        this.fetchCategories(); // Внутри хранилища уже реализована проверка
      }
    },
    data: () => ({
      modules: [Navigation, Scrollbar, Pagination],
    }),
    components: {
      Gender,
      Swiper,
      SwiperSlide,
      search
    }
}
</script>
